"use client";

import {
  createWorkspaceBlock,
  createWorkspacePage,
  fetchWorkspacePage,
  type WorkspacePageSummary,
} from "@/lib/api/workspace-pages";
import { blocksToDocument } from "./workspaceDocument";

/**
 * Копия страницы: то же название, то же содержимое, следующей строкой за
 * исходной.
 *
 * Вынесено из сайдбара, потому что дублировать страницу умеют теперь два места
 * (обычный сайдбар и панель новой версии), а порядок вызовов тут неочевидный:
 * сначала читаем страницу целиком, потом создаём пустую рядом с исходной и
 * только затем кладём в неё документ. Если поменять шаги местами, копия
 * появится в конце списка или окажется пустой.
 */
export async function duplicateWorkspacePage(pageId: string, options?: {
  /** Магазин копии: id, "all" или null «как по умолчанию». */
  storeRef?: string | null;
  /** Название копии; по умолчанию — как у исходной. */
  title?: string;
}): Promise<WorkspacePageSummary> {
  const source = await fetchWorkspacePage(pageId);
  const created = await createWorkspacePage(options?.title ?? source.title, { insertAfterId: pageId });
  await createWorkspaceBlock(created.id, "document", { text: "", doc: blocksToDocument(source.blocks) });
  // Магазин — отдельным запросом: он задаётся уже после того, как копия
  // существует, а класть его в создание значило бы протаскивать магазин через
  // общий путь создания страницы, где он не нужен.
  if (options && "storeRef" in options) {
    await fetch(`/api/workspace-pages/${created.id}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ storeRef: options.storeRef ?? null }),
    });
  }
  return created;
}
